export default "__VITE_ASSET__pyQEXlux__"